// extracted by mini-css-extract-plugin
export default {"heading":"AdPlacement_heading__8A+Ki","wrapper":"AdPlacement_wrapper__uto43"};